import * as tslib_1 from "tslib";
import classnames from 'classnames';
import React from 'react';
import Dropdown from '../../Dropdown';
import IconButton from '../../../Button/IconButton';
import StandardMenu from '../StandardMenu';
import s from './IconWithDropdown.scss';
var IconWithDropdown = /** @class */ (function (_super) {
    tslib_1.__extends(IconWithDropdown, _super);
    function IconWithDropdown() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconWithDropdown.prototype.render = function () {
        var _a = this.props, icon = _a.icon, items = _a.items, className = _a.className, menuClassName = _a.menuClassName, menuAlignment = _a.menuAlignment, usePortal = _a.usePortal, disabled = _a.disabled, noIconHoverEffect = _a.noIconHoverEffect, lightText = _a.lightText, onOpen = _a.onOpen, biData = _a.biData;
        return (React.createElement(Dropdown, { menuAlignment: menuAlignment, className: classnames(s['root'], className), usePortal: usePortal, onOpen: onOpen },
            React.createElement(Dropdown.Toggle, { tabIndex: "-1" },
                React.createElement(IconButton, { disabled: disabled, noHoverEffect: noIconHoverEffect, biData: biData }, icon)),
            React.createElement(StandardMenu, { className: classnames(s['menu'], menuAlignment === 'right' && s['align-right'], menuClassName), lightText: lightText, items: items })));
    };
    return IconWithDropdown;
}(React.Component));
export default IconWithDropdown;
//# sourceMappingURL=IconWithDropdown.js.map